export default __webpack_public_path__ + "static/media/git.5e9c1f97.webp";